import { Vue } from 'vue-property-decorator'
import { NavigationButtons, RrPerson } from '@/commons/types'

export class ApplicantButtonUtils {
    static generateApplicantNavigationButtons (
        context: Vue,
        personSelfTranslationKey: string,
        personApplicantsButtonTranslationKey: string,
        basePath: string,
        person: RrPerson | null,
        underCareAndWardens: Array<RrPerson>
    ): Array<NavigationButtons> {
        if (!person?.personCode) {
            return []
        }

        const navigationButtons: Array<NavigationButtons> = [
            {
                buttonText: `${context.$t(personSelfTranslationKey)}`,
                path: `${basePath}/create/${person.personCode}`
            }
        ]

        for (const applicant of underCareAndWardens) {
            if (!applicant || !applicant.firstName || !applicant.lastName || !applicant.personCode) {
                continue
            }

            navigationButtons.push({
                buttonText: `${context.$t(personApplicantsButtonTranslationKey, {
                    personName: `${applicant.firstName} ${applicant.lastName}`
                })}`,
                path: `${basePath}/create/${applicant.personCode}`
            })
        }
        return navigationButtons
    }
}
